// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38f4e3ee","732":"c4f91a87","977":"0d43a35c"}[chunkId] + ".chunk.js";
};